import { useSelector } from "react-redux";
import { clearCarnetsMap, createCarnets, selectState } from "../main.slice";
import { selectState as selectStateCarnets, } from "../../Carnets/carnets.slice";
import { CarnetType } from "Dashboard/scenes/Carnets/domain/CarnetType";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import { FormatDateIso } from "utils/dateUtils";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { ICarnetCreate } from "Dashboard/scenes/Carnets/domain/ICarnetCreate";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { CARNET_MODULE_NAME } from "Dashboard/scenes/Carnets/domain/CarnetModule";

const AddCarnetsButton = () => {
  const { carnetsMap, carnetsDateMap } = useSelector(selectState);
  const { selectedProjectId, selectedDateFrom, selectedDateTo } =
    useSelector(selectStateCarnets);
  const { user } = useSelector(selectStateAuth);

  const dispatch = useAppDispatch();

  const getDate = (employeeId: number) => {
    const carnetsDates = Object.keys(carnetsDateMap).map(
      (key) => carnetsDateMap[parseInt(key)]
    );
    const currentDate = FormatDateIso(new Date());
    const itemDate = carnetsDates.find((item) => item.employeeId === employeeId);
    if (itemDate !== undefined) {
      return itemDate.carnetDate;
    }
    return currentDate;
  }

  const mergeCarnetsWithDates = (carnets: ICarnetCreate[]) => {
    const sendingData: ICarnetCreate[] = carnets.map((c) => {
      return { ...c, carnetDate: getDate(c.employeeId) };
    });
    return sendingData;
  }

  const handleCreateCarnets = async () => {
    const carnets = Object.keys(carnetsMap).map(
      (key) => carnetsMap[parseInt(key)]
    );
    if (carnets.length === 0) {
      toast.info("Morate uneti neki karnet.");
      return;
    }
    const badInputs = carnets.filter(
      (c) =>
        c.carnetType === CarnetType.EMPLOYED &&
        (c.projectId === null ||
          (c.carnetHours?.every(hour => hour === undefined)))
    );
    if (badInputs.length > 0) {
      toast.error("Morate uneti oznacena polja.");
      return;
    }

    const sendingData = mergeCarnetsWithDates(carnets);

    try {
      await dispatch(
        createCarnets({
          carnets: sendingData,
          projectId: selectedProjectId,
          dateFrom: selectedDateFrom,
          dateTo: selectedDateTo,
        })
      ).unwrap();
      dispatch(clearCarnetsMap());
      toast.success("Karneti su uspešno uneseni.");
    } catch (response: any) {
      if (response.status === 404) {
        if (response.data.message !== undefined && response.data.message.startsWith("HourlyWork requires a non zero rate value when hours is positive")) {
          toast.error("Nije moguć unos karneta jer nije uneta cena radnih sati u ljudskim resursima.");
        } else {
          toast.error("Nije moguć unos karneta jer neki od unetih parametara nije regularan.");
        }
      } else if (response.status === 406) {
        toast.warn("Nije dozvoljen unos karneta više od jednog radnog dana u prošlost. Potreban vam je pun pristup modulu karneti.");
      } else if (response.status === 409) {
        toast.warn("Nije dozvoljena izmena karneta koji je uneo drugi korisnik. Potreban vam je pun pristup modulu karneti.");
      } else if (response.status === 403) {
        toast.error("Nije dozvoljen unos karneta (za izabranog zaposlenog na izabrani dan, ili vi niste zaposleni u firmi, ...).");
      } else if (response.status === 412) {
        if (response.data.message !== undefined && response.data.message.startsWith("Payroll is locked")) {
          toast.error("Plata za mesec za koji unosite karnete je isplaćena i karneti se više ne mogu unositi niti menjati.");
        } else {
          toast.error("Nije dozvoljen unos karneta jer nisu podešene vrednosti za bolovanje i odmor u podešavanjima aplikacije.");
        }
      } else if (response.status === 400) {
        toast.error("Karneti nisu uneti zbog neočekivane greške.");
      }
    }
  };

  return (
    <ToolboxButton
      icon={ToolboxButtonIcon.ArrowCircleDown}
      onClick={hasWriteAccessTo(user, CARNET_MODULE_NAME) ? handleCreateCarnets : undefined}
    />
  );
};

export default AddCarnetsButton;
